"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boolean = void 0;
const w_not = (context) => {
    context.pushBoolean(!context.popBoolean());
};
const w_and = (context) => {
    const b = context.popBoolean();
    const a = context.popBoolean();
    context.pushBoolean(a && b);
};
const w_or = (context) => {
    const b = context.popBoolean();
    const a = context.popBoolean();
    context.pushBoolean(a || b);
};
const w_xor = (context) => {
    const b = context.popBoolean();
    const a = context.popBoolean();
    context.pushBoolean(a !== b && (a || b));
};
exports.boolean = [
    ["boolean:not", w_not],
    ["boolean:and", w_and],
    ["boolean:or", w_or],
    ["boolean:xor", w_xor],
];
